import { Icon } from "./Icon.tsx";

/** Subcatchment-group icon (ElementBrowser.tsx's own "Subcatchments" header) — the same drawn-outline shape as AddSubcatchmentIcon.tsx, without its "+" badge (this represents the group, not the "add one" action). */
export function SubcatchmentIcon() {
  return (
    <Icon>
      <path d="M2 20l1-9 6-2 5 3v8z" />
    </Icon>
  );
}
